import _ from 'lodash'

import config from '../../../../../../../../../../../config'

import {
    ADDRESSES_RUIAN_ID_CHANGE,
    ADDRESSES_GET_FIRMS_ON_ADDRESS_TABLE_REQUEST,
    ADDRESSES_GET_FIRMS_ON_ADDRESS_SUMMARY_REQUEST,
    ADDRESSES_FIRMS_ON_ADDRESS_DATA_RECEIVED,
    ADDRESSES_FIRMS_ON_ADDRESS_TABLE_CHANGE,
    ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_TRUE,
    ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_FALSE,
} from './constants'

export function addressesRuianIdChange(module, id, block, level, customData, ruianId) {
    return {
        type: ADDRESSES_RUIAN_ID_CHANGE,
        data: {
            module,
            id,
            block,
            level,
            customData,
            ruianId,
        },
    }
}

export function addressesGetFirmsOnAddressSummaryRequest(module, id, block, level, token, lang, ruianId) {
    return {
        type: ADDRESSES_GET_FIRMS_ON_ADDRESS_SUMMARY_REQUEST(id),
        payload: {
            uri: _.get(config, `api.${module}.${block}.shared.summary.uri`),
            qs: {
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                ruianId,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function addressesGetFirmsOnAddressTableRequest(module, id, block, level, token, lang, ruianId, qp) {
    return {
        type: ADDRESSES_GET_FIRMS_ON_ADDRESS_TABLE_REQUEST(id),
        payload: {
            uri: _.get(config, `api.${module}.${block}.shared.table.uri`),
            qs: {
                ...qp,
                lang,
                token,
                level,
            },
            uriParams: {
                entId: id,
                ruianId,
                lang,
            },
            headers: {
                'X-Token': token,
            },
        },
    }
}

export function addressesFirmsOnAddressDataReceived(module, id, block, customData) {
    return {
        type: ADDRESSES_FIRMS_ON_ADDRESS_DATA_RECEIVED,
        data: {
            module,
            id,
            blockKey: block,
            customData,
        },
    }
}

export function addressesFirmsOnAddressTableChange(module, block, id, level, customData, ruianId, queryParams) {
    return {
        type: ADDRESSES_FIRMS_ON_ADDRESS_TABLE_CHANGE,
        data: {
            module,
            blockKey: block,
            id,
            level,
            customData,
            ruianId,
            queryParams,
        },
    }
}

export function addressesFirmsOnAddressTableLoadingTrue(module, id, blockKey, customData) {
    return {
        type: ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_TRUE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function addressesFirmsOnAddressTableLoadingFalse(module, id, blockKey, customData) {
    return {
        type: ADDRESSES_FIRMS_ON_ADDRESS_TABLE_LOADING_FALSE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
